import BaseAPI from "../api";

const path: string = "admission_admin";

export class AdmissionAdminApi extends BaseAPI {
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static verified(id: number): Promise<any> {
    return this.api.patch(`${path}/admission_students/${id}/verified`);
  }
  static rejected(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/admission_students/${id}/rejected`, body);
  }

  static list(query?: any): Promise<any> {
    return this.api.get(`${path}/admission_students`, {
      params: { ...query },
    });
  }
  static listPaymentTerm(query?: any): Promise<any> {
    return this.api.get(`${path}/admission_payment_term`, {
      params: { ...query },
    });
  }
  static postPaymentTerm(body: any): Promise<any> {
    return this.api.post(`${path}/admission_payment_term`, body);
  }
  static successPaymentTerm(
    id_admission_student: any,
    body: any
  ): Promise<any> {
    return this.api.patch(
      `${path}/admission_payment_term/${id_admission_student}/success`,
      body,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
  static successPaymentRegister(
    id_admission_student: any,
    body: any
  ): Promise<any> {
    return this.api.patch(
      `${path}/admission_payment_register/${id_admission_student}/success`,
      body,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
  static reviewPaymentTerm(id_admission_student: any, body: any): Promise<any> {
    return this.api.patch(
      `${path}/admission_payment_term/${id_admission_student}/review`,
      body
    );
  }

  static verified_list(query?: any): Promise<any> {
    return this.api.get(`${path}/verified_admission_students`, {
      params: { ...query },
    });
  }
  static report_admission_students(query?: any): Promise<any> {
    return this.api.get(`${path}/report_admission_students`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }
  static report_admission_payment_term(query?: any): Promise<any> {
    return this.api.get(`${path}/admission_payment_term/report`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }
}
